export default "__VITE_ASSET__DOzvyKs___"